import { Icon, type IconName } from "@/components/ui/Icon";
import { useIsDark } from "@/lib/theme";
import { RiveArt, type RiveArtboard } from "./RiveArt";

/** The sidebar icons drawn in Rive (apps/web/rive/tools/gen.py). Any other icon stays Lucide's. */
const ANIMATED: Partial<Record<IconName, RiveArtboard>> = {
  home: "nav-home",
  calendar: "nav-calendar",
  clients: "nav-clients",
  requests: "nav-requests",
  quote: "nav-quote",
  job: "nav-job",
  invoice: "nav-invoice",
  finance: "nav-finance",
  metrics: "nav-metrics",
  clock: "nav-clock",
  truck: "nav-truck",
  book: "nav-book",
  settings: "nav-settings",
  chat: "nav-chat",
};

/**
 * A navigation icon with a light in it: lit while its section is open, playing its motion while the
 * link under it is hovered or focused, and tinted for the theme. `size` is the Lucide size it stands in for.
 */
export function NavIcon({ name, active = false, size = 18 }: { name: IconName; active?: boolean; size?: number }) {
  const dark = useIsDark();
  const artboard = ANIMATED[name];
  const still = <Icon name={name} size={size} />;
  if (!artboard) return still;
  const px = size === 18 ? 20 : size;
  return <RiveArt artboard={artboard} width={px} height={px} inputs={{ active, dark }} hoverFromParent fallback={still} />;
}
